import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'bca-image-upload-dialog',
  template: `
    <bca-image-upload></bca-image-upload>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageUploadDialog {}
